import { Modal } from '$gcomponents/reusables';
import { Div, FONT, SPACE, WEIGHT } from '$gstyles';
import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const IonPageWrapper = styled(IonPage)`
  .metadata {
    .title {
      font-weight: ${WEIGHT.SEMI_BOLD};
    }
    .memo {
      font-size: ${FONT.SMALL};
      opacity: 0.8;
    }
  }
  .MuiTableHead-root {
    border-bottom: 1px solid #ccc;
  }
  .cat-filter {
    width: 100%;
    min-width: 250px;
  }

  /* Folder navigation above the file table */
  .folder-bar {
    margin-bottom: ${SPACE.SMALL};
  }
  .folder-bar .folder-crumbs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${SPACE.MEDIUM};
    flex-wrap: wrap;
    min-height: 34px;
  }
  .folder-bar .crumb-icon {
    vertical-align: middle;
    margin-right: 4px;
  }
  .folder-bar .folder-grid {
    display: flex;
    flex-wrap: wrap;
    gap: ${SPACE.SMALL};
    margin-top: ${SPACE.SMALL};
  }
  .folder-bar .folder-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px 6px 10px;
    border: 1px solid var(--ion-color-light-shade, #d7d8da);
    border-radius: 6px;
    background: var(--ion-color-light, #f4f5f8);
    cursor: pointer;
    min-width: 150px;
    max-width: 240px;
  }
  .folder-bar .folder-chip:hover {
    border-color: var(--ion-color-medium, #92949c);
  }
  .folder-bar .folder-chip:focus-visible {
    outline: 2px solid var(--ion-color-primary);
  }
  .folder-bar .folder-chip-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ModalWrapper = styled(Modal)`
  .modal-header {
    height: 195px;
  }
  .dropzone-wrapper {
    width: 100%;
    height: 90px;
  }
  .youtube-wrapper {
    background-color: #eee;
    padding: ${SPACE.MEDIUM};
    > div {
      padding: ${SPACE.SMALL};
    }
    input {
      background-color: #fff;
    }
  }

  .preview-table {
    input {
      width: 100%;
      width: 100%;
      border-radius: 4px;
      padding: 6px 8px;
      border-color: #ccc;
      border-width: 1px;
    }
  }
`;

export const StoreSelectorWrapper = styled(Div)`
  &.oneline {
    display: flex;
    height: 47px;
    align-items: center;
    padding: 0 ${SPACE.LARGE};

    .store-selector {
      min-width: 300px;
    }
    ion-item {
      --min-height: 42px;
      ion-label {
        margin-top: -10px !important;
      }
    }
    ion-select {
      padding: 4px 0;
    }
  }
`;

